import { FILTER_OP_SEPARATOR } from '@/constants/initiative'
import safeJSONParse from '@/utils/safeJSONParse'

/**
 * This takes filterOp string, and deserializes it. It return an object containing fieldName, operator and value.
 * @param filterOp
 * @returns {{field: *, value: (Object|*|*[]), operator: *}}
 */
export default filterOp => {
  const [field, operator, value] = filterOp.split(FILTER_OP_SEPARATOR)
  return { field, operator, value: safeJSONParse(decodeURIComponent(value)) || [] }
}
